import { defineReactiveModel, PrivateProfileMixin } from "vue-app-utils";
import Model from "@/models/model";

const PrivateProfile = {
  extends: Model,
  mixins: [
    PrivateProfileMixin
  ]
};

export default defineReactiveModel(PrivateProfile);
